import { cn } from "@/lib/utils";
import { useI18n } from "@/lib/i18n";

/** Horizontal RSI gauge 0-100 */
export function RsiGauge({ value }) {
  const pct = Math.max(0, Math.min(100, value));
  const color =
    pct < 30 ? "bg-emerald-500" :
    pct > 70 ? "bg-red-500" : "bg-amber-500";
  return (
    <div className="flex items-center gap-3" data-testid="rsi-gauge">
      <span className="text-[10px] text-zinc-500 w-8">RSI</span>
      <div className="relative flex-1 h-1.5 bg-zinc-800 rounded-sm overflow-hidden" dir="ltr">
        <div className={cn("absolute top-0 bottom-0 right-0", color)} style={{ left: 0, width: `${pct}%` }} />
        <div className="absolute inset-y-0 left-[30%] w-px bg-zinc-700" />
        <div className="absolute inset-y-0 left-[70%] w-px bg-zinc-700" />
      </div>
      <span className="num text-xs text-zinc-300 w-10 text-left">{pct.toFixed(1)}</span>
    </div>
  );
}

export function MacdBar({ hist }) {
  const positive = hist >= 0;
  const magnitude = Math.min(100, Math.abs(hist) * 1000);
  return (
    <div className="flex items-center gap-3" data-testid="macd-bar">
      <span className="text-[10px] text-zinc-500 w-8">MACD</span>
      <div className="relative flex-1 h-1.5 bg-zinc-800 rounded-sm overflow-hidden" dir="ltr">
        <div className="absolute inset-y-0 left-1/2 w-px bg-zinc-600" />
        <div
          className={cn("absolute inset-y-0", positive ? "bg-emerald-500" : "bg-red-500")}
          style={{
            left: positive ? "50%" : `${50 - magnitude / 2}%`,
            width: `${magnitude / 2}%`,
          }}
        />
      </div>
      <span className="num text-xs text-zinc-300 w-10 text-left">{hist.toFixed(4)}</span>
    </div>
  );
}

export function EmaTrend({ price, ema20, ema50 }) {
  const { t } = useI18n();
  const above20 = price > ema20;
  const above50 = price > ema50;
  const trend = above20 && above50 ? t("trend_up") : !above20 && !above50 ? t("trend_down") : t("trend_neutral");
  const color = above20 && above50 ? "text-emerald-400" : !above20 && !above50 ? "text-red-400" : "text-amber-400";
  return (
    <div className="flex items-center gap-3 text-xs" data-testid="ema-trend">
      <span className="text-[10px] text-zinc-500 w-8">EMA</span>
      <div className="flex-1 flex items-center gap-2 text-zinc-400">
        <span className="num">20: {ema20.toFixed(4)}</span>
        <span className="text-zinc-700">·</span>
        <span className="num">50: {ema50.toFixed(4)}</span>
      </div>
      <span className={cn("text-[11px] font-bold", color)}>{trend}</span>
    </div>
  );
}
